var TscButtonSize = {
  normal: 'normal',
  large: 'large',
  auto: 'auto'
};
export default TscButtonSize;